export default {"src":"/_next/static/media/set-blue.dff4c1de.svg","height":630,"width":1200,"blurWidth":0,"blurHeight":0};